<template>
  <local-list ref="list"
              :include-search-field="includeSearchField"
              :show-type-filter="showTypeFilter"
              :allowed-advanced-filters="allowedAdvancedFilters"
              @paginate="onPaginate">
    <template #sidebar-footer>
      <slot name="sidebar-footer" />
    </template>
  </local-list>
</template>

<script>
import GeoipCountryMixin from '@/location-search/geoip-country-mixin'
import { sharedMapPropsMixin } from './shared-map-props'
import { withLocalListMixin } from './with-local-list-mixin'
import LocalList from './local-list'

export default {
  components: { LocalList },

  mixins: [ GeoipCountryMixin, sharedMapPropsMixin, withLocalListMixin ],

  props: {
    eventCreationAllowed: {
      type: Boolean,
      required: false,
      default: undefined
    },
    groupCreationAllowed: {
      type: Boolean,
      required: true
    },
    propFilters: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    eventCreationAllowedOrDefault() {
      if (this.eventCreationAllowed === undefined || this.eventCreationAllowed === null) {
        return !this.agraConfiguration.disablePublicEventCreation
      } else {
        return this.eventCreationAllowed
      }
    },

    // Cannot use the method from filterManagerMixin because it defines an urlFilterKeys property
    // that clashes with the fixed data attribute declared by withLocalListMixin
    propFiltersNotForUrl() {
      return this.propFilters.filter(f => !this.urlFilterKeys.includes(f.type))
    }
  },

  created() {
    this.$store.commit('setEventCreationAllowed', this.eventCreationAllowedOrDefault)
    this.$store.commit('setGroupCreationAllowed', this.groupCreationAllowed)
  }
}
</script>
